import { useLocation, useParams } from 'react-router'
import { URL_API } from '../../../../services/api_url'
import { useAxiosHttpClient } from '../../../../hooks/useAxiosHttpClient'
import CreateContracts from '../../../../pages/Contracts/CreateContracts'
import { RemoteGetSPE } from '../../../../data/usecases/SPE/RemoteGetSPE'
import { RemoteGetProject } from '../../../../data/usecases/Project/RemoteGetProject'
import { RemoteCreateContract } from '../../../../data/usecases/Contracts/RemoteCreateContract'
import { RemoteGetCompanies } from '../../../../data/usecases/Company/RemoteGetCompanies'
import { ContextPageProvider } from '../../../../pages/Contracts/CreateContracts/contextPage'
import { RemoteGetPersons } from '../../../../data/usecases/Persons/RemoteGetPersons'
import { RemoteUpdateContract } from 'data/usecases/Contracts/RemoteUpdateContract'

type ParamsState = {
  contractParams: any
  companyId: string
  id?: string
}

export const CreateContractFactory = () => {
  const URL = URL_API || 'without-url'
  const axiosHttpClient = useAxiosHttpClient()
  const remoteGetSpes = new RemoteGetSPE(URL, axiosHttpClient)
  const remoteGetProjects = new RemoteGetProject(URL, axiosHttpClient)
  const remoteGetPersons = new RemoteGetPersons(URL, axiosHttpClient)
  const remoteCreateContract = new RemoteCreateContract(URL, axiosHttpClient)
  const remoteUpdateContract = new RemoteUpdateContract(URL, axiosHttpClient)
  const remoteGetCompanies = new RemoteGetCompanies(URL, axiosHttpClient)

  const { state } = useLocation<ParamsState>()
  const { id } = useParams<ParamsState>()

  return (
    <ContextPageProvider
      getSpes={remoteGetSpes}
      getProjects={remoteGetProjects}
      getPersons={remoteGetPersons}
      createContract={remoteCreateContract}
      getCompanies={remoteGetCompanies}
    >
      <CreateContracts
        hasContract={state?.contractParams}
        id={state?.id}
        handleUpdate={remoteUpdateContract}
      />
    </ContextPageProvider>
  )
}
